/**
 * WB3-P6-2 — Explanatory AI header pilot gate (entity/internal · finance/flow).
 * Aligns with P6-1 inspector AI layers pilot families.
 */

import type { WorkbenchLayoutEngineRouteFamily } from '@shared/business-workbench/workbench-layout-policy';

export const EXPLANATORY_AI_PILOT_ROUTE_FAMILIES = [
  'entity/internal',
  'finance/flow',
] as const satisfies readonly WorkbenchLayoutEngineRouteFamily[];

export type ExplanatoryAiPilotRouteFamily = (typeof EXPLANATORY_AI_PILOT_ROUTE_FAMILIES)[number];

export const EXPLANATORY_AI_PILOT_DOMAINS = ['internal_entity', 'finance_flow'] as const;

const PILOT_ROUTE_FAMILY_SET = new Set<string>(EXPLANATORY_AI_PILOT_ROUTE_FAMILIES);
const PILOT_DOMAIN_SET = new Set<string>(EXPLANATORY_AI_PILOT_DOMAINS);

export function resolveExplanatoryAiPilotEnabled(input: {
  businessDomain?: string;
  routeFamily?: string | null;
}): boolean {
  if (input.routeFamily && PILOT_ROUTE_FAMILY_SET.has(input.routeFamily)) {
    return true;
  }
  if (input.businessDomain && PILOT_DOMAIN_SET.has(input.businessDomain)) {
    return true;
  }
  return false;
}
